<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <UserNavigationSidebar :toggler.sync="isToggled" />

      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar :profile="getUserProfile" @toggled="toggleSidebarNav" />

      <section>
        <ApplicationsList />
      </section>
    </div>
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import ApplicationsList from '@/components/User/ApplicationsList';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [toggleSidebarNav],
  components: {
    UserNavigationSidebar,
    TopNavbar,
    ApplicationsList,
  },
  data: () => ({ isToggled: false }),
  methods: {
    ...mapActions(['retrieveCandidateUserProfile']),
  },
  computed: { ...mapGetters(['getUserProfile']) },
  mounted() {
    this.retrieveCandidateUserProfile();
  },
};
</script>
